import { Link, useLocation } from 'react-router-dom';
import { TouchNavBar, TouchNavFrame, TouchNavItem } from './styled';
import { useAuth } from '../context/AuthContext';

function TouchNav() {
  const location = useLocation();
  const inBand = /^\/bands\/[^/]+/.test(location.pathname);
  const { can } = useAuth();

  const navItems = [
    {
      label: 'Songs',
      permission: 'songs:read',
      to: '/library/songs',
      isActive: (pathname) => pathname === '/library/songs',
    },
    {
      label: 'Albums',
      permission: 'albums:read',
      to: '/albums',
      isActive: (pathname) => pathname === '/albums',
    },
    {
      label: 'Add Song',
      permission: 'songs:write',
      to: '/songs/new',
      isActive: (pathname) => pathname === '/songs/new',
    },
    {
      label: 'New Album',
      permission: 'albums:write',
      to: '/albums/new',
      isActive: (pathname) => pathname === '/albums/new',
    },
    {
      label: 'Preferences',
      permission: 'app:access',
      to: '/preferences',
      isActive: (pathname) => pathname === '/preferences' || pathname.startsWith('/preferences/'),
    },
  ];

  return (
    <TouchNavFrame>
      <TouchNavBar>
        {navItems.filter((item) => can(item.permission) &&
          (!inBand || !['songs:write', 'albums:write'].includes(item.permission))).map((item) => (
          <TouchNavItem
            key={item.label}
            as={Link}
            to={item.to}
            $active={item.isActive(location.pathname)}
          >
            {item.label}
          </TouchNavItem>
        ))}
      </TouchNavBar>
    </TouchNavFrame>
  );
}

export default TouchNav;
